import { defineMessages } from 'react-intl';

export default defineMessages({
    chooseLanguage: {
        id: 'user.chooseLanguage',
        defaultMessage: 'Choose language',
    },
})
